export function createCache() {
    let cached = {};
    const invalidate = (key) => {
        delete cached[key];
    };
    const has = (key) => {
        const result = cached[key];
        if (result) {
            if (result.expiry > Date.now()) {
                return true;
            }
            invalidate(key);
        }
        return false;
    };
    const get = (key) => {
        const cachedEntry = cached[key];
        if (!cachedEntry) {
            return undefined;
        }
        // Double-check expiry when getting
        if (cachedEntry.expiry <= Date.now()) {
            invalidate(key);
            return undefined;
        }
        return cachedEntry.value;
    };
    const set = (key, value, expiry) => {
        cached[key] = { value, expiry: Date.now() + expiry };
        return value;
    };
    const invalidateAll = () => {
        cached = {};
    };
    const invalidateByPattern = (pattern) => {
        Object.keys(cached)
            .filter((k) => pattern.test(k))
            .forEach((k) => invalidate(k));
    };
    return {
        has,
        get,
        set,
        invalidate,
        invalidateAll,
        invalidateByPattern,
    };
}
export function generateKey(url, { headers, body }) {
    return `${url}|${JSON.stringify(headers || {})}|${typeof body === 'string' ? body : JSON.stringify(body || '')}`;
}
// Legacy default export for backward compatibility
export default createCache;
